import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font
} from "@react-pdf/renderer";
import Logo from "../assets/liqueLogo.png";
import dayjs from "dayjs";

// Font.register({
//   family: "Inter",
//   fonts: [
//     { src: "https://fonts.gstatic.com/s/inter/v19/UcCo3FwrK3iLTcviYwY.woff2", fontWeight: "normal" },
//     { src: "https://fonts.gstatic.com/s/inter/v19/UcCo3FwrK3iLTcviYwY.woff2", fontWeight: "bold" },
//   ]
// })

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 20,
    fontFamily: "Helvetica"
  },
  logo: {
    width: 100,
    marginBottom: 20,
  },
  headerText: {
    fontSize: 12,
    textAlign: "left",
    marginBottom: 10,
    fontFamily: "Helvetica"
  },
  section: {
    marginBottom: 10,
    fontFamily: "Helvetica"
  },
  title: {
    fontSize: 16,
    textAlign: "center",
    marginBottom: 20,
    fontFamily: "Helvetica"
  },
  row: {
    flexDirection: "row",
    justifyContent: "start",
    gap: 10,
    fontFamily: "Helvetica"
  },
  label: {
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "Helvetica"
  },
  value: {
    fontSize: 10,
    fontFamily: "Helvetica"
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#222",
    color: "#fff",
    padding: 5,
    fontFamily: "Helvetica"
  },
  tableRow: {
    flexDirection: "row",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontFamily: "Helvetica"
  },
  tableFooter: {
    flexDirection: "row",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontFamily: "Helvetica",
    fontWeight: "bold"
  },
  tableCell: {
    flex: 1,
    fontSize: 10,
    fontFamily: "Helvetica"
  },
  total: {
    fontFamily: "Helvetica",
    fontWeight: "bold",
    textAlign: "right",
    marginTop: 10,
  },
  padding: {
    padding: 10,
  },
  rowChild: {
    width: "48%",
    flexGrow: 1,
    // padding: 10,
    fontFamily: "Helvetica"
  }
});

const PartnerTransactionPDF = ({ transactionData, dateFrom, dateTo, isFromWithdrawal = false }) => {
  let totalIncome = 0;
  let totalPrice = 0;
  let totalDiscount = 0;
  let totalCommission = 0;
  let totalWithdrawal = 0;

  const filteredTransaction = transactionData.transactionList.filter(transaction => {
    if (transaction.type === 'W') {
      totalWithdrawal += transaction.price;
    } else {
      totalPrice += transaction.price;
      totalDiscount += transaction.discountValue;
      totalCommission += transaction.commission;
    }

    return transaction.type !== 'W'
  });

  const partnerData = transactionData.partner;

  totalIncome = totalPrice - totalDiscount - totalCommission;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <Image src={Logo} style={styles.logo} />
          <View>
            <Text style={{ fontSize: 12 }}>Bukti Terima Penghasilan</Text>
          </View>
        </View>

        <View style={styles.section}>
          <View style={{ ...styles.row, marginBottom: 3 }}>
            <View style={styles.rowChild}>
              <Text style={styles.label}>{partnerData.name}</Text>
            </View>
            <View style={styles.rowChild}>
              <Text style={styles.label}>Catatan Transaksi dari{"\n"}{dateFrom?.format("DD/MM/YYYY")} - {dateTo?.format("DD/MM/YYYY")}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.rowChild}>
              <Text style={{ ...styles.value }}>{partnerData.address}</Text>
            </View>
            <View style={styles.rowChild}>
              <View style={{ ...styles.value, flexDirection: "row", marginBottom: 2 }}>
                <Text style={{ width: "40%", flexGrow: "1" }}>Username</Text> 
                <Text style={{ width: "60%", flexGrow: "2" }}>: {partnerData.username}</Text>
              </View>
              <View style={{ ...styles.value, flexDirection: "row", marginBottom: 2 }}>
                <Text style={{ width: "40%", flexGrow: "1" }}>Bank</Text>
                <Text style={{ width: "60%", flexGrow: "2" }}>: {partnerData.bankName}</Text>
              </View>
              <View style={{ ...styles.value, flexDirection: "row", marginBottom: 2 }}>
                <Text style={{ width: "40%", flexGrow: "1" }}>Nama Rekening Bank</Text>
                <Text style={{ width: "60%", flexGrow: "2" }}>: {partnerData.bankAccountName}</Text>
              </View>
              <View style={{ ...styles.value, flexDirection: "row", marginBottom: 2 }}>
                <Text style={{ width: "40%", flexGrow: "1" }}>No. Rekening Bank</Text>
                <Text style={{ width: "60%", flexGrow: "2" }}>: {partnerData.bankAccountNo}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.tableHeader}>
          <Text style={styles.tableCell}>
            { isFromWithdrawal ? "Dana yang Ditransfer" : "Total Transaksi" }
          </Text>
          <Text style={[styles.tableCell, { textAlign: "right" }]}>Jumlah (IDR)</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={styles.tableCell}>Harga Produk</Text>
          <Text style={[styles.tableCell, { textAlign: "right" }]}>
            {`Rp ${totalPrice.toLocaleString("id-ID")}`}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tableCell}>Voucher & Diskon</Text>
          <Text style={[styles.tableCell, { textAlign: "right" }]}>
            {`Rp ${totalDiscount.toLocaleString("id-ID")}`}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tableCell}>Biaya Komisi</Text>
          <Text style={[styles.tableCell, { textAlign: "right" }]}>
            {`Rp ${totalCommission.toLocaleString("id-ID")}`}
          </Text>
        </View>

        <Text style={styles.total}>
          Total Penghasilan: {`Rp ${totalIncome.toLocaleString("id-ID")}`}
        </Text>

        <Text style={{ marginTop: 20, fontSize: 10, fontWeight: "bold" }}>Rincian Data Penghasilan</Text>

        <View style={styles.tableHeader}>
          <Text style={styles.tableCell}>Tgl Pesanan Selesai</Text>
          <Text style={styles.tableCell}>Subtotal Pesanan</Text>
          <Text style={styles.tableCell}>Voucher & Potongan Harga</Text>
          <Text style={styles.tableCell}>Komisi</Text>
          <Text style={styles.tableCell}>Total Penghasilan</Text>
        </View>

        {
          filteredTransaction.map(transaction => (
            <View style={styles.tableRow} key={transaction.id}>
              <Text style={styles.tableCell}>{dayjs(transaction.transactionDate).format("DD/MM/YYYY")}</Text>
              <Text style={styles.tableCell}>{`Rp ${transaction.price.toLocaleString("id-ID")}`}</Text>
              <Text style={styles.tableCell}>{`- Rp ${transaction.discountValue.toLocaleString("id-ID")}`}</Text>
              <Text style={styles.tableCell}>{`- Rp ${transaction.commission.toLocaleString("id-ID")}`}</Text>
              <Text style={styles.tableCell}>{`Rp ${transaction.totalTransaction.toLocaleString("id-ID")}`}</Text>
            </View>
          ))
        }

        <View style={styles.tableFooter}>
          <Text style={styles.tableCell}>Total Penghasilan</Text>
          <Text style={styles.tableCell}>{`Rp ${totalPrice.toLocaleString("id-ID")}`}</Text>
          <Text style={styles.tableCell}>{`- Rp ${totalDiscount.toLocaleString("id-ID")}`}</Text>
          <Text style={styles.tableCell}>{`- Rp ${totalCommission.toLocaleString("id-ID")}`}</Text>
          <Text style={styles.tableCell}>{`Rp ${totalIncome.toLocaleString("id-ID")}`}</Text>
        </View>

        <Text style={{ fontSize: 8, marginTop: 10 }}>
          Jika ada pertanyaan mengenai laporannya, silakan hubungi tim kami.
        </Text>

        <Text style={{ fontSize: 8, marginTop: 20 }}>
          © Copyright Lique Store {dayjs().format("YYYY")}. All Right Reserved
        </Text>
      </Page>
    </Document>
  );
};

export default PartnerTransactionPDF;
